import React from 'react'
import styled from 'styled-components'
import { useStateMachine } from 'little-state-machine'
import { useTranslation } from 'react-i18next'
import { Store } from './Scale'

type Props = {
  allQuestionsLength: number
}

function calculatePercentage(num: number, index: number): number {
  return ((index + 1) / num) * 100
}

export const Progress = React.memo(({ allQuestionsLength }: Props) => {
  const {
    state: { inquery },
  } = useStateMachine<Store>()
  const { t } = useTranslation('translation')
  const valueNowInPercentage: number = calculatePercentage(allQuestionsLength, inquery.activeIndex);
  const valueMinInPercentage: number = calculatePercentage(allQuestionsLength, 0);

  return (
    <ProgressRow>
      <span id="progress-meter-title">{t('inquiryProgress.title')}:</span>
      <Container role="meter" aria-valueNow={valueNowInPercentage} aria-valueMin={valueMinInPercentage} aria-valueMax="100" aria-labelledby="progress-meter-title">
        <Content
          $width={valueNowInPercentage}
        />
      </Container>
    </ProgressRow>
  )
})

const ProgressRow = styled.div`
  display: flex;
  align-items: center;
  margin-left: auto;
  span {
    padding-right: 1em;
  }
`

const Content = styled.div<{ $width: number }>`
  width: ${(props) => `${props.$width}%`};
  height: 100%;
  background: var(--color-primary);
  border-radius: 1.5rem;
`

const Container = styled.span`
  width: 15rem;
  height: 1.5rem;
  border-radius: 1.5rem;
  background: #f4f4f4;
  border: 2px solid #f4f4f4;
  display: flex;
  justify-content: flex-start;
`
